import { atom } from 'jotai';
import { atomWithDefault } from 'jotai/utils';
import { IProviderConfigDataModel } from '../../../data-models/provider-config.data-model';
import { getProviderConfig } from '../../../services/queries/MappingsQueries';

/**
 * Bumped to the current timestamp whenever a provider field is
 * successfully updated. Consumers (`MappingsGrid`, `useMappingsRowData`)
 * read this to trigger a re-fetch of provider data after a mapping change.
 */
export const lastFieldUpdateDateStateJ = atom<string | null>(null);

export const providersConfigState = atomWithDefault<
  IProviderConfigDataModel<unknown>[] | Promise<IProviderConfigDataModel<unknown>[]>
>(() => getProviderConfig());

export const providerConfigByNameMapState = atom(async (get) => {
  const providersConfig = await get(providersConfigState);
  return (
    providersConfig?.reduce((res, config) => {
      return res.set(config.provider, config);
    }, new Map<string, IProviderConfigDataModel<unknown>>()) ?? null
  );
});
